var _style, _path, _path2, _path3, _path4;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgLogout = function SvgLogout(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96.7 103.6",
    style: {
      enableBackground: "new 0 0 96.7 103.6"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.logout{fill:current;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "logout",
    d: "M71.1,67.2c-0.9-0.5-1.4-1.4-1.4-2.4v-2.7H50.9c-1.5,0-2.7-1.2-2.7-2.7c0,0,0,0,0,0V48.7c0-1.5,1.2-2.7,2.7-2.7 l0,0h18.8v-2.7c0-1.5,1.2-2.7,2.7-2.7c0.5,0,1,0.2,1.5,0.5L90,51.8c1.2,0.8,1.6,2.5,0.7,3.7c-0.2,0.3-0.4,0.5-0.7,0.7L73.9,67 C73,67.6,72,67.7,71.1,67.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "logout",
    d: "M64.3,10.7v29.9H50.9c-0.9,0-1.8,0.2-2.7,0.5V26.8c0-3-1.7-5.8-4.5-7.2L20.6,8h41.1C63.1,8,64.3,9.2,64.3,10.7 C64.3,10.7,64.3,10.7,64.3,10.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "logout",
    d: "M50.9,67.5h13.4v18.8c0,1.5-1.2,2.7-2.6,2.7c0,0,0,0-0.1,0H48.2V67C49,67.3,50,67.5,50.9,67.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "logout",
    d: "M41.3,24.4L9.1,8.3C8.2,7.9,7.3,7.9,6.5,8.4c-0.8,0.5-1.3,1.4-1.3,2.3v75.6c0,1.1,0.7,2.2,1.8,2.5l32.3,10.8 c0.8,0.3,1.7,0.2,2.4-0.3c0.7-0.5,1.1-1.3,1.1-2.2V26.8C42.8,25.8,42.2,24.9,41.3,24.4z M32.1,59.4c0,1.5-1.2,2.7-2.7,2.7 c-1.5,0-2.7-1.2-2.7-2.7V48.7c0-1.5,1.2-2.7,2.7-2.7c1.5,0,2.7,1.2,2.7,2.7V59.4z"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogout, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Logout.20f38252.svg";
export { ForwardRef as ReactComponent };